<template>
  <div class="c-notification-holder" :class="{'is-badge':badge}">
    <span class="c-notification-holder__counter" v-if="count > 0">{{displayCount}}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "NotificationCount",

  computed: {
    displayCount() {
      if (this.count > 99) {
        return "99+";
      }

      return this.count;
    }
  },
  props: {
    count: {
      type: [Number, String],
      default: 0
    },
    badge: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.c-notification-holder {
  display: inline-flex;
  position: relative;
  width: 39px;

  &__counter {
    font-size: 14px;
    font-weight: bold;
    color: white;
    background: $colour-nhs-emergency-red;
    box-sizing: border-box;
    padding: 2px 6px;
    border-radius: 50px;
    line-height: 1;
    min-width: 16px;
    box-shadow: 0 1px 0 darken($colour-nhs-emergency-red, 20%);
  }

  &.is-badge & {
    &__counter {
      font-size: 12px;
      position: absolute;
      top: -3px;
      left: -5px;
      padding: 2px 4px 3px;
      z-index: 5;
    }
  }
}
</style>